// extracted by mini-css-extract-plugin
export default {"contributionBlockedBanner":"EmuContributionBlockedBanner-module__contributionBlockedBanner--ULSSa"};